import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import SeniorDetail from './components/SeniorDetail';
import LoginPage from './components/LoginPage';
import { useAuth } from 'react-oidc-context';
import { useEffect } from 'react';
import ErrorBoundary from './components/ErrorBoundary';
function ActualApp() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Dashboard />} />
        {/* <Route path='/dashboard' element={<Dashboard />} /> */}
        <Route
          path='/senior/:senior_id'
          element={
            <ErrorBoundary>
              <SeniorDetail />
            </ErrorBoundary>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

// App.js

function App() {
  const auth = useAuth();

  // Clean up URL after successful authentication
  useEffect(() => {
    if (auth.isAuthenticated && !auth.isLoading) {
      // Check if URL contains OAuth/OIDC parameters
      const url = new URL(window.location.href);
      const hasOAuthParams =
        url.searchParams.has('code') ||
        url.searchParams.has('state') ||
        url.searchParams.has('session_state') ||
        url.hash.includes('access_token') ||
        url.hash.includes('id_token');

      if (hasOAuthParams) {
        // Clean URL by removing query parameters and hash
        const cleanUrl = `${window.location.origin}${window.location.pathname}`;
        window.history.replaceState(null, '', cleanUrl);
        console.log('Cleaned OAuth parameters from URL');
      }
    }
  }, [auth.isAuthenticated, auth.isLoading]);

  const signOutRedirect = () => {
    const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
    const logoutUri = import.meta.env.VITE_COGNITO_POST_LOGOUT_REDIRECT_URI;
    const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  };

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    console.error('Auth error details:', auth.error);
    return <div>Encountering error... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return (
      // <div>
      //   <pre> Hello: {auth.user?.profile.email} </pre>
      //   <pre> ID Token: {auth.user?.id_token} </pre>
      //   <pre> Access Token: {auth.user?.access_token} </pre>
      //   <pre> Refresh Token: {auth.user?.refresh_token} </pre>

      //   <button onClick={() => auth.removeUser()}>Sign out</button>
      // </div>
      <ActualApp />
    );
  }
  console.log('auth.settings:', auth.settings);
  return <LoginPage />;
}

export default App;
